document.addEventListener('DOMContentLoaded', () => {
    const searchButton = document.querySelector('.ofra-button-search');
    const searchContainer = document.querySelector('.ofra-search__scrolled');
  
    const toggleSearch = () => {
      searchContainer.classList.toggle('active');
      searchButton.classList.toggle('hidden');
    };

    searchButton.addEventListener('click', (e) => {
      e.stopPropagation();
      toggleSearch();
    });


    document.addEventListener('click', (e) => {
      if (!searchContainer.contains(e.target) && !searchButton.contains(e.target)) {
        searchContainer.classList.remove('active');
        searchButton.classList.remove('hidden');
      }
    });

    searchContainer.addEventListener('click', (e) => {
      e.stopPropagation();
    });

});

document.addEventListener('DOMContentLoaded', () => {
  const navbar = document.querySelector('.ofra-navbar');

  window.addEventListener('scroll', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop >70) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  });
});